import "@babel/polyfill";
import 'promise-polyfill/dist/polyfill';
import $ from 'jquery';
import SidetextSlider from './SidetextSlider';
import Slider3Cards from './Slider3Cards';
import LoverTabs from './LoverTabs';
import HorizTabs from './HorizTabs';
import MenuMobile from './MenuMobile';
import MenuDesktop from './MenuDesktop';
import SpriteSheet from './SpriteSheet';
import SwipeSlides from './SwipeSlides';
import ZoomTwo from './ZoomTwo';
import InnerZoom from './InnerZoom';
import ModalCompra from './ModalCompra';
import ProductBubbles from './ProductBubbles';
import { usarTamanhoSalvo } from './TamanhoSalvo';

global.$ = global.jQuery = $;

const IS_DEVELOPMENT = false;

SwipeSlides(IS_DEVELOPMENT);

// @ START DETECT
window.IS_TAP_ENABLED = false;
// window.USER_CAN_HOVER = false;
// Detectar touch / mouse
// https://codeburst.io/the-only-way-to-detect-touch-with-javascript-7791a3346685
window.addEventListener('touchstart', function onFirstTouch() {
  // we could use a class
  document.body.classList.add('user-is-touching');

  // or set some global variable
  window.IS_TAP_ENABLED = true;

  // or set your app's state however you normally would
  // myFrameworkOfChoice.dispatchEvent('IS_TAP_ENABLED', true);

  // we only need to know once that a human touched the screen, so we can stop listening now
  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

// window.addEventListener('mouseover', function onFirstHover() {
//   window.USER_CAN_HOVER = true;
//   window.removeEventListener('mouseover', onFirstHover, false);
// }, false);
// @ END DETECT


// Scripts GTAG, Facebook, etc...
setTimeout(() => require('./3party'), 1000);



$(document).ready(function() {
	// Debug
  // $('a').click(function(e) {
	//   e.preventDefault();
	//   e.stopPropagation();
	// });
  initHeaderMenu();
  initMainTabs();
  require('./TamanhoTabs');
  HorizTabs.start();
  handleHorizontalTabsScroll();
  initVideoColo();
  ProductBubbles();

  require('./Contato');
  require('./PageComprar');

	setTimeout(() => {
    ZoomTwo(IS_DEVELOPMENT);
    InnerZoom(IS_DEVELOPMENT);
    ModalCompra(IS_DEVELOPMENT);
    usarTamanhoSalvo();
    require('./AnimatedBubbles');

    setTimeout(() => {
      LoverTabs.start();
      initNovaGeracaoSlider();

      setTimeout(() => {
        require('./ParallaxAnimations');
      }, 1000);
    }, 1500);
	}, 2500);
		


  setTimeout(() => {
    initInstagram();
	}, 8000);
});



function initHeaderMenu() {
  new MenuMobile('#btn-mobile-menu', '#mobile-menu-content');
  new MenuDesktop('#site-header-desktop');

  var mnUrl = function(uri) {
    let prefix = '';
    if(IS_DEVELOPMENT) {
      prefix = './assets';
    } else {
      prefix = './assets';
    }

    return prefix + uri;
  };

  // Animations
  $('.sprite-banheira').each(function() {
    new SpriteSheet().build($(this), 41, 24, mnUrl('/img/sprites/sprite_banheira.png')).start();
  });

  $('.sprite-fralda').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_fralda.png')).start();
  });

  $('.sprite-spray').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_spray.png')).start();
  });

  $('.sprite-talco').each(function() {
    new SpriteSheet().build($(this), 35, 24, mnUrl('/img/sprites/sprite_talco.png')).start();
  });
  // novos
  $('.sprite-calculadora').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_calculadora.png')).start();
  });
  $('.sprite-calendario').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_calendario.png')).start();
  });
  $('.sprite-cha').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_cha.png')).start();
  });
  $('.sprite-checklist').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_checklist.png')).start();
  });
  $('.sprite-diy').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_diy.png')).start();
  });
  $('.sprite-quizz').each(function() {
    new SpriteSheet().build($(this), 50, 24, mnUrl('/img/sprites/sprite_quizz.png')).start();
  });
}



function initNovaGeracaoSlider() {
  let novaGeracaoLinks = $('.homepage .nova-geracao-link');
  let horizWrapper = $('#nova-geracao-horizontal');

  if(novaGeracaoLinks.length) {
    let novaGeracaoSlider = SidetextSlider('.sidetext-slider');

    novaGeracaoSlider.onChange(function(index) {
      novaGeracaoLinks.removeClass('active');
      let activeLink = $(novaGeracaoLinks[index]);
      activeLink.addClass('active');
      // Alterar posição do scroll
      let sliLeft = activeLink.position().left;
      let sliWidth = activeLink.width();
      let scrLeft = horizWrapper.scrollLeft();
      let scrWidth = horizWrapper.width();
      let winWidth = $(window).width();
      // horizWrapper.css('margin-left', -1 * sliLeft + sliWidth / 2);
      // console.log({sliLeft, sliWidth, scrLeft, winWidth});
      let posCenter = scrLeft + sliLeft - ((winWidth/2) - (sliWidth/2));
      // if(posCenter < 0) posCenter = 0;
      // if(posCenter > scrWidth - winWidth) posCenter = scrWidth - winWidth;
      horizWrapper.animate({scrollLeft: posCenter});
    });

    novaGeracaoLinks.each(function(index) {
      let nLink = $(this);
      nLink.click(function(index) {
        novaGeracaoSlider.openSlide(index);
        // novaGeracaoLinks.removeClass('active');
        // this.addClass('active');
      }.bind(nLink, index));
    });
    novaGeracaoLinks.filter(':first').addClass('active');
  }
}



function initInstagram() {
  // Preencher fotos do instagram
  let instaurl = 'https://api.instagram.com/v1/users/self/media/recent?access_token=538164439.1677ed0.fd6e550f98c841b6bb54ce51ad16091d';
  $.get(instaurl, function(response) {
    // console.log('insta: ', response);

    if(response.meta && response.meta.code === 200) {
    let slides3 = [];
    
    for(let i=0; i<response.data.length; i++) {
      let slide = response.data[i];
      let slideImg = {
      thumbnail: slide.images && slide.images.standard_resolution && slide.images.standard_resolution.url,
      link: slide.link,
      title: slide.caption && slide.caption.text || '',
      };

      if(slideImg.thumbnail) {
      slides3.push(slideImg);
      }
    }

    Slider3Cards('.slider-3cards', slides3);
    }
  });
}

/**
 * Alguns menus de tabs precisam ser scrollados horizontalmente se a tela for pequena demais
 * por outro lado, se a tela for grande demais o scroll some
 * Como eu não consegui fazer por CSS, eu coloquei no javascript uma função pra fazer isso
 */
function handleHorizontalTabsScroll() {
  return;
  $('[data-horizontal-tabs-scroll]').each(function() {
    let el = $(this);
    el.css({
      'width': '100%',
      'overflow-y': 'hidden',
      'overflow-x': 'hidden',
      'white-space': 'nowrap',
    });
    setTimeout(() => {
      let minWidth = this.scrollWidth;
      console.log('set width to ', minWidth);
      el.css({'width': minWidth});
    }, 20000);
  });
}


/**
 * Essa função faz com que, ao clicar no botão "play" do container "Benefícios do Colo",
 * abra um modal com um vídeo dentro e dê um play no vídeo
 */
function initVideoColo() {
  let elBtn = $('.play');
  let elModal = $('#modal-beneficios-colo');
  let elWrapper = $('.beneficios-do-colo');
  let elBgVideo = elWrapper.find('.background-video-wrapper');
  let videoId_desktop = elModal.attr('data-desktop-video-id') || 'b_RO1t1LAWo';;
  let videoId_mobile = elModal.attr('data-mobile-video-id') || 'Ui47NBjsh_o';

  function mobileBackgroundVideo() {
    elBgVideo.css({
      'opacity': '0.6',
      'background-image': "url('https://img.youtube.com/vi/" + videoId_desktop + "/maxresdefault.jpg')"
    });
  }

  // Botar o background apenas quando for um touch screen
  if(window.IS_TAP_ENABLED) {
    mobileBackgroundVideo();
  } else {
    window.addEventListener('touchstart', function evtMobVideo() {
      mobileBackgroundVideo();
      window.removeEventListener('touchstart', evtMobVideo);
    });
  }

  let win = $(window);
  
  elBtn.click(() => {
    elModal.modal({fadeDuration: 500, fadeDelay: 0.50});
    
    let winWidth = win.width();
    let winHeight = win.height();

		let elVideo = null;
		let videoId = null;
    if(winWidth < 600 && winWidth < winHeight) {
      videoId = videoId_mobile;
      // elVideo = '<video class="mobile-video" controls autoplay src="./assets/videos/pompom_30s_9x16_facebook.mp4" width="100%"></video>';
      elVideo = '<iframe class="mobile-video" width="300" height="534" src="https://www.youtube.com/embed/'+videoId+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else {
      videoId = videoId_desktop;
      // 560   315
      // 1000  563
      let vWidth = winWidth - 10/100;
      let vHeight = vWidth * 41/100;
      elVideo = '<iframe class="desktop-video" width="'+vWidth+'" height="'+vHeight+'" src="https://www.youtube.com/embed/'+videoId+'?rel=0&amp;autoplay=1&playsinline=1&controls=0&rel=0&autohide=1&modestbranding=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    }
    setTimeout(() => {
      let wrapperVideo = elModal.find('.modal-beneficios-video');
      wrapperVideo.html(elVideo);
      $('.jquery-modal').on('click.remvideo', (e) => {
        if(e.target.nodeName.toUpperCase() === 'VIDEO' || e.target.nodeName.toUpperCase() === 'IFRAME') return;
        $('.jquery-modal').off('click.remvideo');
        setTimeout(() => {
          wrapperVideo.html('');
          $('.modal-beneficios-video').html('');
        }, 700);
      });
    }, 500);
  });
}



/**
 * Centralizar o menu principal que fica em todas as páginas
 * mostrando link pra outros produtos
 */
function initMainTabs() {
  let elTabsWrapper = $('.heart-tabs-horizontal');
  let elActiveTab = elTabsWrapper.find('.active');
  if(!elActiveTab.length) return;
  let winWidth = $(window).width();
  let pos = elActiveTab.offset();
  let width = elActiveTab.width();
  let widthSobrando = winWidth - width;
  elTabsWrapper.scrollLeft(pos.left - (widthSobrando / 2));
}
